import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import TimeRangeSlider from '../../../CustomComponents/Slider/TimeSlider';
import { convertToTimeFormat } from '../../../../utils';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { appTheme } from 'helpers/utils/Utils';
import { useSelector } from 'react-redux';


const NotificationFilter = ({ NotificationFromTime, NotificationToTime, updateTimeFrame, TimeSelectionLable, isReset }) => {
    // debugger;
    const { t } = useTranslation();
    const minTime = convertToTimeFormat(NotificationFromTime)
    const maxTime = convertToTimeFormat(NotificationToTime)
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const startTime = "12:00 AM";
    const endTime = "11:59 PM"


    const [timeForReceivingText, setTimeForReceivingText] = useState(false);
    const [selectedMinTime, setSelectedMinTime] = useState(minTime);
    const [selectedMaxTime, setSelectedMaxTime] = useState(maxTime);

    useEffect(() => {
        updateTimeFrame(selectedMinTime, selectedMaxTime);
    }, [selectedMinTime, selectedMaxTime])

    useEffect(() => {
        if (!timeForReceivingText) {
            setSelectedMinTime(startTime);
            setSelectedMaxTime(endTime);
        }
    }, [timeForReceivingText])

    useEffect(() => {
        if (minTime === startTime && maxTime === endTime) setTimeForReceivingText(false);
        else setTimeForReceivingText(true);

        setSelectedMinTime(minTime);
        setSelectedMaxTime(maxTime);

    }, [isReset])



    return (
        <div className=' flex flex-col gap-10 sm:gap-0 md:gap-10'>
            <div className=" flex flex-row justify-between">
                <p className="font-hanken-grotesk font-[500] text-[14px] leading-[20px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[18px] text-[var(--Timeclr)] w-1/2 sm:w-[85%]">{TimeSelectionLable}</p>
                <p className='flex-grow text-right'>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            id="notification-time-toggle"
                            name="notification-time-preference"
                            type="checkbox"
                            value="time-preference"
                            checked={timeForReceivingText}
                            aria-label="Toggle preferred time for receiving notifications"
                            tabIndex={0}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    setTimeForReceivingText(event.target.checked)
                                }
                            }}
                            onChange={(e) => {setTimeForReceivingText(e.target.checked);logFirebaseEvents("Configure_Notification", "Prefered_Time_Clicked", "Prefered_Time_Clicked", "","")}}
                            className="sr-only peer" />
                        {
                                timeForReceivingText ? (
                                <>
                                <img src={appThemeData.Toggle_Selected} alt="" className="hidden sm:block" />
                                <img src={appThemeData.Toggle_Mobile_Selected} alt="" className="block sm:hidden" />
                                </>
                                ) : (
                                <>
                                <img src={appThemeData.Toggle} alt="" className="hidden sm:block" />
                                <img src={appThemeData.Toggle_Mobile} alt="" className="block sm:hidden" />
                                </>
                                )
                        }
                        <span class="ml-3 text-sm font-medium text-gray-900
                                     dark:text-gray-300"></span>
                    </label>
                </p>
            </div>

            {timeForReceivingText &&
                <div className='flex flex-col lg:flex-row lg:justify-between pt-10'>
                    <p className='font-hanken-grotesk  font-[500] text-[14px] leading-[20px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[18px] text-[var(--Select-time-clr)] pb-[5rem]'>{t("select_time")}</p>
                    <TimeRangeSlider
                        selectedMinTime={selectedMinTime}
                        selectedMaxTime={selectedMaxTime}
                        // Pass two separate arguments to the onDateChangeProp function
                        onTimeChangeProp={(minTime, maxTime) => {
                            setSelectedMinTime(minTime);
                            setSelectedMaxTime(maxTime);
                        }}
                        isReset={isReset}
                    />

                </div>
            }


        </div>
    )
}

export default NotificationFilter

